export enum ENV {
    DEVELOPMENT = 'development',
    PRODUCTION = 'production'
}
